import React, { Component } from 'react';
import './App.css';

import data from './data.json';
import {Layer, Rect, Stage, Group, Circle} from 'react-konva';

import ReactImageMagnify from 'react-image-magnify';
import Slider from 'material-ui/Slider';
import Toggle from 'material-ui/Toggle';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import mapImage from './images/minimap.jpg';

import PlayerComponent from './components/playerComponent';
import SessionComponent from './components/sessionComponent';

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      data: data,
      id: "",
      sessions: [],
      value: 0,
      height: 0,
      width: 0,
      min: -110000,
      max: 110000,
      toggle: false
    };
  }

  map(a){
    return (a - this.state.min)/(this.state.max-this.state.min) * (this.state.height)
  }

  componentDidMount(){
    const height = document.getElementById('main').clientHeight;
    const width = document.getElementById('side').clientHeight;
    this.setState({
      height: height,
      width: width
    });

  }

  getColor(action) {
    if (action == "kill")
      return 'red';
    if (action == "damage")
      return 'blue';
  }

  renderSessions(sessions, playerId) {
    this.setState({
      sessions: sessions,
      id: playerId
    });
    console.log(playerId);
  }

  render() {
    let players = [];
    Object.keys(this.state.data).forEach((player) => {
      players.push({
        name: player,
        player: this.state.data[player]
      });
    });

    let sessions = this.state.sessions.length > 0?
      <SessionComponent
        text={this.state.sessions[this.state.value].id}
      />
      :
      <SessionComponent
        text="Select player"
      />
    ;

    let rects = [];
    if (this.state.sessions.length > 0) {
      let actions = this.state.sessions[this.state.value].session;
      for (let action in actions) {
        rects.push({
          x: this.map(actions[action].attacker_pos_x),
          y: this.map(actions[action].attacker_pos_y),
          action: actions[action].action
        })
      }
    }

    return (
      <div className="App">
        <div id="main" className="mainView middle mapView">
          <div className="row">
            <div id="mapContainer">
              <img width={this.state.height} height={this.state.height} className="img" src={mapImage} alt="Image of map"/>
              <img width={this.state.height} height={this.state.height} className={!this.state.toggle?"none":"img"} src={require('./images/img.png')} alt="sqitter"/>
              <Stage width={this.state.height} height={this.state.height}>
                <Layer>
                  {rects.map(item =>
                    <Circle
                      x={item.x}
                      y={item.y}
                      radius={5}
                      fill={this.getColor(item.action)}
                      shadowBlur={5}
                    />
                  )}
                </Layer>
              </Stage>
            </div>
          </div>

          <div id="upper" className="flex">
            <div>
              <MuiThemeProvider className="flex">
                <Slider
                  className="slider"
                  value={this.state.value}
                  step={1}
                  max={this.state.sessions.length > 0 ? this.state.sessions.length-1 : 1}
                  onChange={(object, value) => this.setState({
                    value: value
                  })}
                />
              </MuiThemeProvider>
            </div>
            <div id="row" >
              <div id="toggleButton" className="flex">
                <MuiThemeProvider>
                  <Toggle
                    className="toggle flex"
                    onToggle={(obj, value) => this.setState({
                      toggle: value
                    })}
                  />
                </MuiThemeProvider>
                <p id="toggleButtonText" className="flex">{"Other players' death positions"}</p>
              </div>
              <div className="flex">
                <p id="textRight" className="basicText">{this.state.value+1}/{this.state.sessions.length > 0 ? this.state.sessions.length : 1}</p>
              </div>
            </div>
          </div>
        </div>

        <div id="side" className="sideBar right listView">
          <div className="header">
            <p className="basicText">Player IDs</p>
          </div>
          {players.map(item =>
            <PlayerComponent
              id={this.state.id}
              player={item.player}
              text={item.name}
              key={item.name}
              call={(sessions, id) => this.renderSessions(sessions, id)}
            />
          )}
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js